import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { auth } from './config/firebase'
import { onAuthStateChanged } from 'firebase/auth'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '@/assets/custom.css'

// Import the tawk.to initialization function
import { initializeTawkWidget } from './utils/tawk'

const app = createApp(App)

// Initialize the widget based on the selected language
initializeTawkWidget()

// Configure the authentication listener
onAuthStateChanged(auth, (user) => {
  store.commit('setUser', user)
})

// Mount the application
app.use(store).use(router).mount('#app')

// Configure a listener for language changes
window.addEventListener('storage', (event) => {
  if (event.key === 'selectedCountry') {
    // Reload the page when the language changes
    window.location.reload()
  }
})
